import * as logger from '@mamdev/navigator.frontend-logger'
import { getAuthCase } from './util/auth-case'
import { getAccessToken } from './util/oauth'
import { getSearchParams } from './util/search-params'
import { handleLogin } from './process/login'
import { handleAbo } from './process/abo'
import { showMessage } from './message-box'
import { getMonitoringService } from './util/monitoring'
import { setLoginTitle } from './util/title'
import { loadTcfApi } from './util/tcf-api'
import { loadPppClient } from './util/ppp'
import { getAuthLibConfig } from './config'

export async function authorize(): Promise<void> {
  const error = getSearchParams().get('error')
  if (error) {
    logger.error(error)
    showMessage()
    return
  }

  const authCase = getAuthCase()
  if (!authCase) {
    logger.error('Missing authCase parameter')
    showMessage()
    return
  }
  logger.debug('authCase', authCase)

  if (authCase === 'login') {
    setLoginTitle()
  }

  if (!getSearchParams().get('code')) {
    getMonitoringService()?.monitorLifecycleLoaded()
  }

  let config
  try {
    config = await getAuthLibConfig()
  } catch (e) {
    logger.error('Failed to load config', e)
    showMessage()
    return
  }


  let accessToken: string
  try {
    accessToken = await getAccessToken(config)
  } catch (e) {
    logger.error('Token Creation Failed', e)
    showMessage()
    return
  }

  if (!accessToken) {
    // if getAccessToken didn't throw but returned null, we're in standalone mode and will be redirected any second now
    return
  }

  logger.debug('access token', accessToken)

  try {
    await Promise.all([
      loadTcfApi(),
      loadPppClient()
    ])
  } catch (e) {
    logger.error(e)
    showMessage()
    return
  }

  if (authCase === 'abo') {
    await handleAbo(accessToken)
    return
  }

  /* istanbul ignore next else */
  if (authCase === 'login') {
    await handleLogin(accessToken)
  }
}

